import React, { useEffect } from 'react';
import { useWhoamiStore } from '@/store/useWhoamiStore.ts';
import posthog from 'posthog-js';

const UserIdentificationProvider: React.FC = () => {
	const { user } = useWhoamiStore();

	useEffect(() => {
		if (user) {
			posthog.identify(user.id?.toString(), {
				email: user.email,
				name: `${user.firstName} ${user.lastName}`,
				role: user.spotnanaRole,
				organization_id: user.organization?.id,
				organization_name: user.organization?.name,
			});

			posthog.group('organization', user.organization!.id.toString(), {
				name: user.organization?.name,
			});
		} else {
			posthog.reset();
		}
	}, [user?.id]);

	return null;
};
export default UserIdentificationProvider;
